import { createContext, RefObject, useContext } from 'react';

export type DrawerDirection = 'top' | 'right' | 'bottom' | 'left';

export const DrawerDirectionContext = createContext<DrawerDirection>('right');

export function useDrawerDirection() {
  return useContext(DrawerDirectionContext);
}

export const DrawerScrollContext =
  createContext<RefObject<HTMLDivElement> | null>(null);

/** The drawer panel is the scrolling element, so effects that track scrolling
 * inside a drawer need its ref rather than one of their own. */
export function useDrawerScrollContainer() {
  const ref = useContext(DrawerScrollContext);

  if (!ref) {
    throw new Error(
      'useDrawerScrollContainer must be used within a Drawer.Content'
    );
  }

  return ref;
}
